module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "i365"
    }
  }), _c('a', {
    attrs: {
      "id": "i772"
    }
  }), _c('a', {
    attrs: {
      "id": "i785"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-42"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "chap2"
  }, [_vm._v("CHAPTER 4")]), _vm._v(" "), _c('h4', {
    staticClass: "sect1"
  }, [_vm._v("August 1981")]), _vm._v(" "), _c('p', {
    staticClass: "noindentk"
  }, [_vm._v("It was an image that would stick in Joe Estey’s mind for a long time afterward. It wasn’t like most memories, fading gradually over the years. If anything, this one seemed to get more vivid, more disturbing, especially after he had children of his own.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Estey had turned thirty that spring but he was a latecomer to police work. A lot of people who ended up as cops had decided in high school, or even earlier, that that was what they wanted to be, and many of them started their careers soon after high school or military service. Estey hadn’t become a cop until he was twenty-six, and by then he had tried a lot of other things. He had grown up and graduated from high school in Brattleboro, a small city near the Vermont bank of the Connecticut River, and headed off to Boston University, thinking about majoring in physical education. Once there he found he had no idea why he was doing it and left after a year. He had worked at a ski area, managed a clothing store, sold furniture. One day he saw an ad in the newspaper for a part-time deputy sheriff. For some reason, maybe it was just boredom, he went to take the exam.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It was really just a lark,” Estey recalled, but he did well on the test and got the job. After a one-week course in the basics he started working a few hours a week, guarding county prisoners being transported from one place to another, working security details at school dances and basketball games, still working full-time at the furniture store. There was a kind of romance to wearing the uniform, and the variety of the work was always stimulating, so when there was an opening for a fulltime juvenile officer Estey put in his application. He got the job.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It wasn’t long before Estey knew he had found a career. Coming late to police work had given him time to see cops from the other side of the badge. He knew they could often seem stiff and intimidating to the"), _c('a', {
    attrs: {
      "id": "i227"
    }
  }), _c('a', {
    attrs: {
      "id": "i282"
    }
  }), _c('a', {
    attrs: {
      "id": "i326"
    }
  }), _c('a', {
    attrs: {
      "id": "i773"
    }
  }), _c('a', {
    attrs: {
      "id": "i786"
    }
  }), _c('a', {
    attrs: {
      "id": "i822"
    }
  }), _c('a', {
    attrs: {
      "id": "i832"
    }
  }), _c('a', {
    attrs: {
      "id": "i857"
    }
  }), _c('a', {
    attrs: {
      "id": "i858"
    }
  }), _c('a', {
    attrs: {
      "id": "i865"
    }
  }), _c('a', {
    attrs: {
      "id": "i2085"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-43"
    }
  }), _vm._v(" ordinary citizen. His own approach was low-key, unassuming, and people seemed to respond well to him. Soon he moved on to the Springfield "), _c('a', {
    attrs: {
      "id": "i2319"
    }
  }), _vm._v("Police Department, thirty miles north of Brattleboro, and by the summer of 1981 he was the department’s chief investigator.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Estey was at home enjoying the soft early evening of a summer Saturday when the phone rang.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Joe, you’d better come on in,” the voice said. “We’ve got a girl missing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Theresa Fenton had begged for permission to go on a bike ride. She had been up late the night before at a slumber party with girlfriends, and she had gone into town earlier in the day to a backyard fair a girlfriend was giving to raise money for a muscular dystrophy charity. It seemed like enough for one day, and it was getting close to dinnertime, but when she persisted her parents gave in. At twelve she was a lively and confident child, pushing steadily at the limits of her independence. She wanted to ride a circular route, but her parents asked her instead to take a shorter trip, heading south on the Old Connecticut River Road and then retracing her route back home, a total of four miles or so. Theresa agreed and set out a little after six o’clock.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As six-thirty passed and the time crept toward seven and beyond, at the Fentons’ house attention became concern and concern became worry. Could Theresa have broken the agreement with her parents, seeking to challenge herself, and pedalled farther along the River Road to make the loop back on Route 5? It wasn’t like her to defy authority in that way, but what else could have delayed her?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Family members set out to look for her, and the word quickly spread to neighbors along Putnam Road. Several volunteered to help in the search. A number of passes along her planned route turned up no trace. At eight o’clock it was growing dark; Theresa’s grandmother called the Springfield Police Department.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was a poignancy to the description of Theresa in the police broadcast that undercut the idea of the strong, independent person who had set out on her own for a bike ride: a girl well under five feet, weighing about ninety pounds, wearing blue jeans and sneakers. It was a child that was missing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As Joe Estey and other officers were assembling at the Springfield Police Department, a neighbor of the Fentons, twenty-nine-year-old Richard "), _c('a', {
    attrs: {
      "id": "i705"
    }
  }), _vm._v("Craig, was heading out to join the family’s search. He drove south with a companion along Route 5 and took the fork onto the River Road. As dark fell, Craig perched on the hood of the car with a flashlight, scanning the areas at the edge of the road and beyond that were"), _c('a', {
    attrs: {
      "id": "i250"
    }
  }), _c('a', {
    attrs: {
      "id": "i523"
    }
  }), _c('a', {
    attrs: {
      "id": "i949"
    }
  }), _c('a', {
    attrs: {
      "id": "i1169"
    }
  }), _c('a', {
    attrs: {
      "id": "i1225"
    }
  }), _c('a', {
    attrs: {
      "id": "i1287"
    }
  }), _c('a', {
    attrs: {
      "id": "i1304"
    }
  }), _c('a', {
    attrs: {
      "id": "i1656"
    }
  }), _c('a', {
    attrs: {
      "id": "i2438"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-44"
    }
  }), _vm._v(" not touched by the sweep of the headlights. Past the thin margin of woods next to the pavement, a bank dropped off to the river flowing peacefully through the night below.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They had been searching about forty-five minutes when the car reached a place where the bank dropped off steeply to the river. Something just beyond the rim of the roadside border returned a small sliver of the flashlight’s beam. "), _c('a', {
    attrs: {
      "id": "i706"
    }
  }), _vm._v("Craig peered over the edge, then scrambled down the bank. A bicycle lay in the brush several feet below the top of the bank. The flashlight’s rays had reflected off a piece of the bike’s chrome. It was a girl’s bike and it looked like Theresa Fenton’s. They rushed back to report their find.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The bike was quickly identified as Theresa’s. The place where it had been found was about two miles from her house, next to the route she had promised to take. She had kept to the agreement with her parents.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By eight-thirty the police search was organized and volunteers all over town were dropping their normal Saturday evening activities to join in. Besides the police officers dispatched by the Springfield department, off-duty policemen, city firemen, and volunteer firefighters joined the neighbors and friends who had begun the search. As word spread among the searchers that the bicycle had been found, the focus narrowed to the area along the River Road and Route 5 north and south of the discovery site. Volunteers continued to arrive throughout the evening, until there were dozens of people combing the woods and fields. When the "), _c('a', {
    attrs: {
      "id": "i823"
    }
  }), _vm._v("last of them quit at two-thirty in the morning, no further sign of the missing girl had turned up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The location of the bicycle near the top of the steep bank suggested that Theresa might have fallen down the slope and into the river. By six in the morning the searchers had assembled again. Joe "), _c('a', {
    attrs: {
      "id": "i756"
    }
  }), _vm._v("Estey and Vermont state trooper Mike LeClair organized the police and civilian volunteers, dispatching groups in every direction from the focal point where the bicycle had been found.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Half a dozen men with masks and wetsuits had also showed up; in addition to a diving team from the Springfield "), _c('a', {
    attrs: {
      "id": "i1020"
    }
  }), _c('a', {
    attrs: {
      "id": "i2320"
    }
  }), _vm._v("Police Department and another from the Vermont "), _c('a', {
    attrs: {
      "id": "i2469"
    }
  }), _vm._v("State Police, two local men, amateurs, had volunteered to help out. They slipped into the water below the spot where the bicycle had been found and began combing the river bed and the banks downstream. An official from New Hampshire, which owns the Connecticut River to the low-water mark on the Vermont side, showed up to oversee the water search.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Meanwhile, searchers fanned out along the logging roads and trails to the north and south of the place where the bicycle had been found,"), _c('a', {
    attrs: {
      "id": "i307"
    }
  }), _c('a', {
    attrs: {
      "id": "i776"
    }
  }), _c('a', {
    attrs: {
      "id": "i829"
    }
  }), _c('a', {
    attrs: {
      "id": "i1289"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-45"
    }
  }), _vm._v(" searching the woods and gravel banks. To the west, away from the river, lines of volunteers pushed through the fields where corn stood higher than a man’s head. Police officers checked the few houses to ask if anyone had seen a strange car or anything unusual. Overhead, another local man who had volunteered his services tracked back and forth in his helicopter, searching roads and clearings.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bloodhounds were brought to the place where the bicycle had lain. They seemed to pick up a scent briefly, then became confused.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By one o’clock the divers had searched a large swath of river without turning up a clue. The water was clear and moving calmly. They were convinced that if she had fallen in they would have found some sign. That, and the bloodhounds’ failure to find a trail leading away from the site, suggested that Theresa might have left the scene in a car.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A little after two o’clock a Springfield man named Torrey "), _c('a', {
    attrs: {
      "id": "i2495"
    }
  }), _vm._v("Walters and his two children left their car just off Mile Hill Road, about ten miles from the center of the "), _c('a', {
    attrs: {
      "id": "i866"
    }
  }), _vm._v("search for Theresa Fenton, and walked down a gravel road into the woods. They were going for a few hours of fishing, but in general this was an area where people went not so much to find nature as to avoid the scrutiny of others; beer cans and plastic bags, the remains of drinking parties, cluttered the side of the road and the occasional clearing. There were signs here and there that the woods had been used for target practice or the illegal dumping of trash.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A few hundred yards down the road they turned off into the undergrowth, heading toward the stream. As his children scrambled in their cheerful orbits around him, Walters slowly became aware of a sound that separated itself from the gentle hum of nature on a sunny summer afternoon. He turned his head until he located its source in a tangle of brush. It was difficult to identify at first, a sound that seemed so out of place in this mild and happy time, but after a moment it resolved itself into something distinctly human: it was a low moaning sound.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Walters moved toward the sound to investigate. As he waded into the brushy tangle, a movement caught his eye. A foreign shape raised itself from a clump of dirt and leaves. It was an arm, a thin, pale arm, waving weakly in the air.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ten miles away, the call on the car radio came to Joe Estey like a punch in the stomach.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They’ve found her, Joe. She’s hurt, hurt bad. Over by Mile Hill Road.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ah, shit,” he said, in a long sighing whisper.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was surprising how much hope had survived the eighteen hours of fruitless searching since Estey had received the first phone call at home."), _c('a', {
    attrs: {
      "id": "i777"
    }
  }), _c('a', {
    attrs: {
      "id": "i830"
    }
  }), _c('a', {
    attrs: {
      "id": "i1170"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-46"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All along, without thinking about it, he had been hoping that Theresa Fenton would come walking out of the woods, safe, whole, happy. It was only now that he fully realized the extent of this hope, at the moment when he felt it leaving him in a rush that was almost physical, as if all the air had been sucked out of his body.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Estey and Mike LeClair, the state police detective, turned onto the narrow gravel lane off Mile Hill Road as the ambulance crew was preparing to leave. Theresa Fenton was still alive.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Estey set about his work, the routine of investigation, talking to Torrey "), _c('a', {
    attrs: {
      "id": "i2496"
    }
  }), _vm._v("Walters, examining the place where Theresa Fenton had been found. The bottles and scattered bits of litter gave the place a shabby look. Dirt and leaves mixed with hemlock needles had been scraped into a low pile, partly covering the girl’s body. Blood had seeped into the ground and congealed on the spot where she had lain.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The fisherman described what he had heard, the moaning sound that had drawn his attention, and what he had seen, the frail arm of a child, a watch on the wrist, waving haltingly in the air. It had been as if she were trying to summon help.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And that was the image that Joe Estey would never be able to escape. It was a scene he had never viewed himself, and yet it burned itself into his mind as if it had come to him in a nightmare. He thought of the child, torn in a moment from the reassuring certainties of her life, knowing somewhere in her consciousness that she must be gravely injured, lying overnight in the unknown, in the dark and cold. A child, alone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And from that terrible isolation, a small arm reached out bravely against the dark, begging for help that could not come in time.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-957cd298","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Chapter_04.vue
// module id = 96
// module chunks = 0